import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import PlatformSection from './components/PlatformSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import RegisterSection from './components/RegisterSection';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const target = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (target) {
      const attempt = () => {
        const el = document.querySelector(target);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      };
      const timer = setTimeout(attempt, 120);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [location.state]);

  return (
    <main className="min-h-screen bg-[#EFEBE5]">
      <NavBar />
      <HeroSection />
      <PlatformSection />
      <HowItWorksSection />
      <BenefitsSection />
      <AboutSection />
      <ComparisonSection />
      <RegisterSection />
      <Footer />
      <CookieBanner />
    </main>
  );
}
